import { render, staticRenderFns } from "./not-allow.vue?vue&type=template&id=974c5206&scoped=true"
import script from "./not-allow.vue?vue&type=script&lang=js"
export * from "./not-allow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974c5206",
  null
  
)

export default component.exports